"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M19.877 6.796a18.763 18.763 0 01-1.75 1.74 6.3 6.3 0 01-1.012 1.007c-.437.452-.792.984-1.382 1.283V7.254c-.013-1.943-3.668-1.943-3.682 0v10.167c.16.725.491 1.28 1.288 1.372h1.106c.758-.13 1.189-.587 1.288-1.372v-2.199c0-.762-.143-2.048.368-1.282.75.73 1.807 1.515 2.763 2.38.918.832 1.796 2.176 2.761 2.381 1.978.422 2.85-1.466 2.118-2.838-.773-1.45-2.999-2.379-3.959-3.664.647-1.472 4.164-2.377 3.867-4.945-.117-1.014-1.018-1.504-1.93-1.495-.754.007-1.515.358-1.844 1.037zM9.361 4a1.6 1.6 0 00-.911.273c-.604.414-.94 1.69-1.345 2.599-.446 1-.838 2.007-1.273 2.74-1.177-1.325-1.98-4.263-3.396-5.34-.458-.346-1.46-.336-1.911 0-1.22.913.004 2.527.495 3.373 1.078 1.856 2.272 3.844 3.184 5.55-.592 1.553-3.586 5.94.425 5.692.971-.623 1.382-1.92 1.91-3.093 1.08-2.4 1.997-4.473 3.113-6.955.465-1.031 1.583-2.555 1.345-3.723-.133-.652-.882-1.117-1.636-1.116z" }), "YK");
//# sourceMappingURL=YK.js.map